module.exports = __webpack_public_path__ + "img/translationeditor_5.18d1c7b4.jpg";